export const createTransaccionAdapter = (tx:any) => ({
    CierreLote: tx.cierreLote ? tx.cierreLote : "",
    IdTransaccion: tx.idTransaccion ? tx.idTransaccion : 0,
    IdProducto: tx.id_producto
})

//export excel
export const transaccionesAdapter = (tx:any) => ({
    Nro: tx.nro,
    Cierre_lote: tx.cierreLote,
    Solución: tx.solucion,
    Numero_de_terminal: tx.numeroTerminal,
    Total_sin_descuento: tx.montoSinDescuento,
    Total: tx.monto,
})
//export excel detalle
export const transaccionesDetallesAdapter = (tx:any) => ({
    Cierre_lote: tx.cierreLote,
    Comprobante: tx.numero_comprobante_terminal,
    Fecha: tx.fecha_transaccion,
    Producto: tx.desc_producto,
    Solución:tx.desc_solucion,
    Cantidad: tx.cantidad_Litros,
    total_sin_descuento: tx.montoSinDescuento,
    Importe: tx.monto,
    Id_transaccion: tx.id_transaccion,
    Id_servicio: tx.id_servicio,
    Cupon: tx.cupon,
    Nro_autorizacion: tx.numeroAutorizacion,
    Vog_code: tx.vog_code,
})
//export excel
export const transaccionesMFAdapter = (tx:any) => ({
    Cliente: tx.idCliente,
    Fecha_de_solicitud: tx.fechaTransaccion,
    Solicitud: tx.idSolicitud,
    Presupuesto: tx.idPresupuesto,
    Patente: tx.patente,
    Monto: tx.monto,
})
//export excel detalle
export const transaccionesDetallesMFAdapter = (tx:any) => ({
    Producto: tx.nombreProducto,
    Impuesto: tx.impuesto,
    Monto: tx.monto,
})
